export default __webpack_public_path__ + "static/media/pnina.f8f359cc.png";